// app/channels/index.js
import './consumer'

// Always load user channel for authenticated users
import('./user')

// Always load ticket alerts (for all pages)
import('./tickets')

// Conditionally load channel subscriptions based on current page
const currentPath = window.location.pathname

if (currentPath.includes('/conversations/sdr') || currentPath.includes('/conversations/support')) {
  // Load conversation channel for chat pages
  import('./conversations')
}
